import { FunctionComponent } from 'react';

interface Props {
  error: string;
}

export const FormattedError: FunctionComponent<Props> = ({ error }) => {
  return <code dangerouslySetInnerHTML={{ __html: formatDiffMessage(error) }} />;
};

const escapeHtml = (unsafe: string): string => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const formatDiffMessage = (error: string): string => {
  let finalMessage = '';
  finalMessage = escapeHtml(error);
  return finalMessage.replace(/(?:\r\n|\r|\n)/g, '<br />');
};
